import { render, staticRenderFns } from "./ListOfActivePostmenModal.vue?vue&type=template&id=543ee528&scoped=true&"
import script from "./ListOfActivePostmenModal.vue?vue&type=script&lang=js&"
export * from "./ListOfActivePostmenModal.vue?vue&type=script&lang=js&"
import style0 from "./ListOfActivePostmenModal.vue?vue&type=style&index=0&id=543ee528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ee528",
  null
  
)

export default component.exports